const autocompleteModalEquipServQuest = {
  group: 'Section'
};

export default autocompleteModalEquipServQuest;
